import React, { Component } from "react";

import Layout from "../header_footer/Layout";

import Jumbotron from "../utils/Jumbotron";

import EssenciaSmall from "../utils/EspacosSmall/EssenciaSmall";

import PropTypes from "prop-types";

import axios from "axios";

import Masonry from "react-masonry-component";

import "./essencia.css";

export default class Essencias extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      essencias: [],
    };
  }

  componentDidMount = () => {
    this.loadEssencias();
  };

  loadEssencias = async () => {
    let res = {};
    try {
      res = await axios.get("/api/essencias", {
        params: {},
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    let essencias = res.data.arrayEssencias;

    this.setState({ essencias });
  };

  essenciaClicked = (identifier) => {
    this.context.router.history.push("/essencia/" + identifier);
  };

  render() {
    return (
      <Layout>
        <div className="header">
         
          <h1>Essência</h1>
          <p>
            No Parque Natural da Serra da Estrela, encontra-se o Sabugueiro, a
            aldeia mais recôndita e próxima do cume da Serra da Estrela, erguida
            e aconchegada entre montes e naturalmente protegida por rochedos de
            granito.
          </p>

        </div>

        <div className="container">
          <div className="row">
          {this.state.essencias.map(
              function (item) {
                return (
                  <EssenciaSmall
                    entityClicked={this.essenciaClicked}
                    item={item}
                    key={item.name}
                  ></EssenciaSmall>
                );
              }.bind(this)
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
